import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { WorldpayTabState } from './WorldpayTab.state';
import { WorldpayChallengeForm, WorldpayChallengeIframe, WorldpayChallengeWrapper } from './WorldpayTab.style';

interface WorldpayChallengePropsType {
    state: WorldpayTabState;
}

export const WorldpayChallenge = observer(
    'WorldpayChallenge',
    ({ state }: WorldpayChallengePropsType): JSX.Element | null => {
        const { challengeData } = state;

        if (challengeData === null) {
            return null;
        }

        const { url, jwt, reference, backendOrigin } = challengeData;

        return (
            <ChallengeIframe
                url={url}
                jwt={jwt}
                reference={reference}
                backendOrigin={backendOrigin}
                onComplete={state.handleChallengeComplete}
                onError={state.handleChallengeError}
            />
        );
    }
);

interface ChallengeIframePropsType {
    url: string;
    jwt: string;
    reference: string;
    backendOrigin: string;
    onComplete: (challengeReference: string) => void;
    onError: () => void;
}

const ChallengeIframe = ({
    url,
    jwt,
    reference,
    backendOrigin,
    onComplete,
    onError,
}: ChallengeIframePropsType): JSX.Element => {
    const formRef = React.useRef<HTMLFormElement>(null);

    React.useEffect(() => {
        const onMessage = (event: MessageEvent): void => {
            if (event.origin !== backendOrigin) return;
            const data = event.data;
            if (data?.type === '3ds-challenge-complete' && data?.challengeReference === reference) {
                onComplete(data.challengeReference);
            }
        };

        window.addEventListener('message', onMessage);
        formRef.current?.submit();

        return (): void => {
            window.removeEventListener('message', onMessage);
        };
    }, [url, jwt, reference, onComplete, onError]);

    return (
        <WorldpayChallengeWrapper>
            <WorldpayChallengeIframe name='challenge-iframe' />
            <WorldpayChallengeForm
                ref={formRef}
                method='POST'
                action={url}
                target='challenge-iframe'
            >
                <input
                    type='hidden'
                    name='JWT'
                    value={jwt}
                />
            </WorldpayChallengeForm>
        </WorldpayChallengeWrapper>
    );
};
